var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyFlagShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "46px",
    viewBox: "0 0 62 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KeyFlagShadow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KeyFlagShadow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8559468,43.2962341 C54.9771566,45.719619 59.1504593,46.3134729 60.3758549,45.0777957 C62.2139483,43.2242799 55.0376938,38.0435882 55.0376938,36.0542293 C55.0376938,34.72799 56.8170808,33.7578784 60.3758549,33.1438944 C63.4304629,31.2596672 58.4743787,26.7584366 45.5076025,19.6402026 C32.5408262,12.5219686 17.3716254,5.9752344 4.156675e-13,3.55271368e-15 L3.88586957,10.5176347 L47.8559468,43.2962341 Z",
    id: "Fill-296",
    fill: "#E0DCF2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyFlagShadow);
export default __webpack_public_path__ + "static/media/KeyFlagShadow.19aab15a219f8402a6ccd344bdf90563.svg";
export { ForwardRef as ReactComponent };